module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-sn.258bec8d.png";